export default __webpack_public_path__ + "static/media/680.fe79612b.png";